import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type State = {
  activeRoute: number;
};

type Actions = {
  navigate: (activeRoute: number) => void;
  navigateBack: () => void;
  navigateForward: () => void;
  reset: () => void;
};

const INITIAL_STATE: State = {
  activeRoute: 0,
};

export const useNavigator = create<State & Actions>()(
  devtools((set, get) => {
    return {
      ...INITIAL_STATE,
      navigate: (activeRoute) => set({ activeRoute }),
      navigateBack: () =>
        set(({ activeRoute }) => ({ activeRoute: activeRoute - 1 })),
      navigateForward: () =>
        set(({ activeRoute }) => ({ activeRoute: activeRoute + 1 })),
      reset: () => set(INITIAL_STATE),
    };
  }),
);
